import styled from 'styled-components';

// A fixed frame drawn around the whole viewport as an environment indicator.
// Static rules only - the colour is applied via an inline style so no dynamic
// prop is forwarded to the DOM (styled-components v4 has no transient props).
export const EnvFrame = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-style: solid;
  border-width: 6px;
  pointer-events: none;
  z-index: 2147483647;
`;

// A small centred tab at the top edge naming the environment.
export const EnvLabel = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 12px;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #ffffff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  pointer-events: none;
  z-index: 2147483647;
`;
